export enum ActionTypes {
    SendFeedback = "SendFeedback",
    Review = "Review",
    Approve = "Approve",
    Reject = "Reject"
}
